import {getRequest, saveRequest} from '@requests/index';
import {v4 as uuid} from 'uuid';
import {setTemplatesDocuments, setZajavls} from '@componentDP/js_react/redux/actions/zajavls';
import {isEmpty} from 'lodash';
import {addNotification, loadingApplication} from '@componentDP/js_react/redux/actions/application';
import {setUidContests} from '@helpers/functions';
import {ZAJAVLS_CONSENT_OR_REFUSAL_PAGE_LOADED} from '../store/actionTypes';

export function setZajavlsConsentOrRefusalPageLoaded(status) {
    return {
        type: ZAJAVLS_CONSENT_OR_REFUSAL_PAGE_LOADED,
        status,
    };
}

export function zajavlsConsentOrRefusalPageInit() {
    return async (dispatch, getState) => {
        const {apiDomainVikon, profileBasic} = getState();
        if (Number(profileBasic.diploma_id) > 0) {
            dispatch(setZajavlsConsentOrRefusalPageLoaded(false));
            const chainPromises = [
                getRequest(`${apiDomainVikon}api/digital_profile/applicant/zajavls`),
                getRequest(`${location.origin}/sveden/update/api_profile_applicant/get_templates.php`),
            ];
            const values = await Promise.all(chainPromises);
            const [zajavls, templatesDocuments] = values;
            if (!zajavls.errors) {
                if (!isEmpty(zajavls)) {
                    zajavls.forEach((zajavl) => {
                        zajavl.uuid = uuid();
                        zajavl.contests = setUidContests(zajavl.request_competitions);
                    });
                }
                dispatch(setZajavls(zajavls));
            }
            if (!templatesDocuments.errors) {
                dispatch(setTemplatesDocuments(templatesDocuments));
            }
            dispatch(setZajavlsConsentOrRefusalPageLoaded(true));
        }
    };
}

export function sendConsentOrRefusalZajavlStatus(zajavlId, data, successSaveCallback) {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const {apiDomainVikon, zajavls} = state;
            const {selectedFileType, fileIds, comment} = data;
            dispatch(loadingApplication(true));
            const requestData = {
                type: selectedFileType,
                unconfirmed_consent_or_denial_files: fileIds,
                comment,
            };
            const sendResult = await saveRequest(`${apiDomainVikon}api/digital_profile/applicant/zajavls/${zajavlId}/actions/attach_confirmed_consent_or_denial`, requestData);
            if (!sendResult.errors) {
                const updatedZajavls = zajavls.map((zajavl) => {
                    return Number(zajavl.id) === Number(zajavlId)
                        ? {...zajavl, ...sendResult}
                        : zajavl;
                });
                dispatch(setZajavls(updatedZajavls));
                dispatch(addNotification({message: 'Отправлено', type: 'success'}));
                await successSaveCallback();
            } else {
                dispatch(addNotification({message: sendResult.errors, type: 'error'}));
            }
        } catch (e) {
            dispatch(addNotification({message: e.message, type: 'error'}));
        } finally {
            dispatch(loadingApplication(false));
        }
    };
}
